import React from "react";
// import specific_location_img from "../../images/ahmedabad.jpg";
import { useNavigate } from "react-router-dom";
import ChatButton from "../../components/ChatButton";
import { APP_NAME } from "../../Utils/constant";
import { handleApplyNow } from "../../Utils/navigation";

const Ahmedabad = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper ahmedabad_banner specific_bg_properties">
          <div className="content_page_banner_wrapper_overlay">
            <h2>Location - Ahmedabad</h2>
          </div>
        </div>

        <div className="text_content_wrapper">
          <div className="text_content">
            <h1 className="page_title mt30 mb20">
            Overcome Your Financial Challenges: Personal Loan for Salaried Professionals in Ahmedabad Available!
            </h1>
            <p>
            MONEY is the pivot on which the present world seems to turn. It plays a key role almost everywhere — whether you want to go on a vacation or want to buy something, whether you plan to dine out with your friends or family or are willing to see a doctor. In short, money fuels your aspirations. However, one usual situation we all are aware of is running out of cash. We must have gone through this. 
            </p>
            <br />
            <p>In such a scenario, we always look to borrow — from friends, family, neighbours, colleagues, etc. Some are fortunate enough to get instant financial assistance. However, many remain worried and helpless. However, you need not worry now because {APP_NAME} is here in Ahmedabad to hold you back.</p>
            <h3 className="mb10">What We Do?</h3>
            <p>We are the best cash advance app, offering instant personal loans online for salaried professionals. We offer a range of loans, such as instant personal loans online for salaried professionals, emergency personal loans, instant small personal loans, long-term loans, and many more to loan seekers in Ahmedabad. If you are a resident of Ahmedabad, seeking instant cash, we welcome you to apply at {APP_NAME}.</p>
            <h3>How to Apply for an Instant Loan in Ahmedabad</h3>
            <p>Applying for an instant personal loan in Ahmedabad is an effortless process. By following these steps, you can secure the funds quickly and efficiently. </p>
            <ul className="content_list">
              <li>
                <b>Step 1: Visit the {APP_NAME} Website</b> Start by navigating to the official {APP_NAME} website at https://snappaisa.com/. Once you’re on the homepage, look for the “Apply Now” button at the top to register as a new user.
              </li>
              <li>
                <b>Step 2: Register as a New User</b> Click on the “Apply Now” button and enter your mobile number. Ensure you accurately enter your mobile number to receive the OPT code sent to your registered mobile number. Hit “Get OPT” and enter the OPT code to proceed.

              </li>
              <li>
                <b>Step 3: Provide Personal, Employment and Income Details </b> After registration, you will need to enter your personal, employment and income details. Make sure to double-check all entries for accuracy, as this information is crucial for your loan eligibility.
              </li>
              <li>
                <b>Step 4: Upload Required Documents</b> Once you’ve filled in your details, you will be prompted to upload the necessary documents for verification. Commonly required documents may include:
                <ul className="content_list">
                  <li>Proof of identity (e.g., government-issued ID)</li>
                  <li>Proof of employment (e.g., pay stubs or employment letter)</li>
                  <li>Proof of income (e.g., bank statements or tax returns)</li>
                </ul>
                <p>Ensure that all documents are clear and legible to avoid any delays in processing.</p>
              </li>
              <li>
                <b>Step 5: Submit Your Application</b>After completing all the sections and uploading your documents, review your application one final time. Once you’re satisfied with the information provided, click the "Submit" button to send your application for review. THAT’S IT YOU NEED TO DO.
              </li>
              <li>
                <b>Step 6: Loan Approval and Disbursal</b> Once you accomplish your loan application process, we meticulously review your application for eligibility. If your application fulfils our requirements, we immediately approve it in no time. Finally, you receive your desired loan amount directly in your bank account
              </li>
            </ul>
            <br />
           
            <div className="button_container flex justify-center mt30">
              <button onClick={() => handleApplyNow(navigate)} className="button_container Link">Apply Now</button>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default Ahmedabad;
